import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Ambiente de pruebas (staging): se activa al definir REACT_APP_API_URL.
// Fuera de buscadores y con una etiqueta fija para no confundirlo con producción.
const IS_STAGING = Boolean(process.env.REACT_APP_API_URL);
if (IS_STAGING) {
  const robots = document.createElement('meta');
  robots.name = 'robots';
  robots.content = 'noindex, nofollow';
  document.head.appendChild(robots);
  document.title = `[PRUEBAS] ${document.title}`;
}

const STAGING_BADGE_STYLE = {
  position: 'fixed', bottom: 12, left: 12, zIndex: 9999, pointerEvents: 'none',
  background: '#f59e0b', color: '#1f1300', padding: '6px 12px', borderRadius: 999,
  font: '700 12px/1.2 system-ui, sans-serif', letterSpacing: '0.04em',
  boxShadow: '0 2px 8px rgba(0,0,0,0.25)',
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
    {IS_STAGING && <div role="status" style={STAGING_BADGE_STYLE}>AMBIENTE DE PRUEBAS</div>}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
